var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hot-nav"},[_c('span',[_vm._v("您所在的位置： ")]),_c('span',{on:{"click":_vm.goIndex}},[_vm._v("网站首页 >")]),_c('span',[_vm._v(_vm._s(_vm.navTitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }